import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { XCircle, ArrowLeft, RotateCcw } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancelPage() {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("booking_id");

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center" data-testid="payment-cancel">
        <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-amber-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Cancelled</h1>
        <p className="text-gray-500 mb-6">
          Your payment was cancelled. Your booking is still saved and you can pay later.
        </p>

        {bookingId && (
          <div className="bg-gray-50 rounded-xl p-4 mb-6">
            <p className="text-sm text-gray-500">Booking Reference</p>
            <p className="text-xl font-mono font-bold text-gray-900">{bookingId}</p>
            <p className="text-xs text-amber-600 mt-2">Payment pending</p>
          </div>
        )}

        <div className="flex flex-col gap-3">
          <button
            onClick={() => window.history.back()}
            className="w-full"
          >
            <Button className="w-full bg-[#36827f] hover:bg-[#2d6f6c]">
              <RotateCcw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </button>
          
          <Link to="/">
            <Button variant="outline" className="w-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>

        <p className="text-xs text-gray-400 mt-6">
          Need help? Contact us at info@costanavarino-transfers.com
        </p>
      </div>
    </div>
  );
}
